<template>
    <div class="text-center my-3 text-silver small d-flex flex-row align-items-center">
        <hr class="flex-fill" />
        <span class="mx-2">
            <slot></slot>
        </span>
        <hr class="flex-fill" />
    </div>
</template>
<script>
    export default {
        name: "Striketrough"
    }
</script>
